<template>
  <v-container fluid fill-height>
    <v-row v-if="errors.length">
      <v-col>
        <v-alert type="error">
          <div v-for="(err,idx) in errors" :key="idx">
            {{err}}
          </div>
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols=12>
        <v-card>
          <v-toolbar color="secondary" dark>
            <v-toolbar-title>
              <v-icon left>mdi-wrench</v-icon>Handling
            </v-toolbar-title>
            <v-spacer />
            <template v-slot:extension>
              <v-tabs v-model="tabs">
                <v-tab>On Cart</v-tab>
                <v-tab>Building</v-tab>
                <v-tab>Shipping</v-tab>
                <v-tab>Shipped</v-tab>
              </v-tabs>
            </template>
          </v-toolbar>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <handling-table status="on cart" />
            </v-tab-item>
            <v-tab-item>
              <handling-table status="building" />
            </v-tab-item>
            <v-tab-item>
              <handling-table status="shipping" />
            </v-tab-item>
            <v-tab-item>
              <handling-table status="shipped" />
            </v-tab-item>
            <v-tab-item>
              <handling-table />
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import HandlingTable from "@components/handling/HandlingTable.vue";

export default {
  components:{
    HandlingTable,
  },
  data() {
    return {
      tabs: 0,
      tableData: [],
      totalCount: 0,
      loading: null,
      options: { sortBy:['serviceLevel'], sortDesc:[true],rowsPerPage: 15 },
    };
  },
  computed:{
    ...mapGetters("pickwave", {buildInPickwave:"buildInPickwave",pickwaveLoading:"loading", pickwaveErrors:"errors"}),
    errors(){
      let err = [
        ...this.pickwaveErrors
      ];
      return err;
    },
  },
  methods: {
    ...mapActions("pickwave", { createAndStartPickWave:"createAndStartPickWave"}),
    open(id) {
      this.$router.push("/build/handling/" + id);
    },
    getServiceLevelColor(sl) {
      if (sl > 20) {
        return "red";
      }
      if (sl > 10) {
        return "orange";
      }
      if (sl > 0) {
        return "green";
      }
    }
  }
};
</script>

<style></style>
